import { IAmendOrderAdapterService } from './amend-order-adapter.interface';
import { IAmendOrderResponse } from '../../interfaces';
import { injectable } from 'inversify';

@injectable()
export class AmendOrderAdapterMock implements IAmendOrderAdapterService {
    amendOrder(): Promise<IAmendOrderResponse> {
        // 1 out of 2 amending should be on error in order to handle the error case.
        if (Math.random() >= 0.5) {
            return Promise.resolve<IAmendOrderResponse>({
                isAccepted: true,
            });
        } else {
            return Promise.resolve<IAmendOrderResponse>({
                isAccepted: false,
                reason: 'An random error occurred on the backend when amending.',
            });
        }
    }
}
